import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TicketsTable } from 'src/app/system-tools/ticket-system/_models';

import { AppStateService } from 'src/app/core/services';
import { TicketsTableApi } from 'src/app/shared/api-models/admin/tickets-table-api.type';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { PageTitle } from 'src/app/system-tools/ticket-system/_models/tickets.enum';
import { TicketSystemService, ViewStateService } from 'src/app/system-tools/ticket-system/_services';

@Component({
	selector: 'crm-client-tickets',
	templateUrl: './client-tickets.component.html'
})
export class ClientTicketsComponent implements OnInit, OnDestroy {
	public tickets: TicketsTableApi[];
	sortConfig: SortConfig = {
		column: '',
		direction: 'asc'
	};

	constructor(
		private appStateService: AppStateService,
		private router: Router,
		public ticketSystemService: TicketSystemService,
		public viewStateService: ViewStateService
	) {}

	ngOnInit(): void {
		this.viewStateService.pageTitle = PageTitle.OPEN_TICKETS;
		this.viewStateService.clientId = this.appStateService.currentClient.Id;
		this.getTickets();
	}

	public onSortClick(newConfig: SortConfig) {
		this.sortConfig = newConfig;
		this.viewStateService.orderByCol = this.sortConfig.column;
		if (this.sortConfig.direction === 'asc') {
			this.viewStateService.orderDesc = true;
			this.sortConfig.direction = 'desc';
		} else {
			this.viewStateService.orderDesc = false;
			this.sortConfig.direction = 'asc';
		}
		this.getTickets();
	}

	public getSortIconClass(column: string): string {
		if (this.sortConfig.column !== column) {
			return 'fas fa-sort';
		}
		return this.sortConfig.direction === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
	}

	public onRowSelect(ticket: TicketsTable): void {
		this.router.navigate([`/ticket-system/edit-ticket/${ticket.Id}`]);
	}

	public onPageClick(pageNumber?: number): void {
		if (pageNumber) {
			this.viewStateService.pageNumber = pageNumber;
		}
		this.getTickets();
	}

	public onIncludeClosedClick(): void {
		this.viewStateService.includeClosed = !this.viewStateService.includeClosed;
		this.getTickets();
	}

	private getTickets(): void {
		this.ticketSystemService.getTableData$().subscribe((tickets: TicketsTableApi[]) => {
			this.tickets = tickets;
		});
	}

	ngOnDestroy(): void {
		this.viewStateService.reset();
	}
}
